import axios from 'axios';
import store from 'store2';
// Get API URL from environment (supports Vite, Next.js, and browser)
function getApiUrl() {
    // Browser runtime
    if (typeof window !== 'undefined') {
        // Vite apps
        const viteEnv = import.meta.env;
        if (viteEnv === null || viteEnv === void 0 ? void 0 : viteEnv.VITE_API)
            return viteEnv.VITE_API;
        if (viteEnv === null || viteEnv === void 0 ? void 0 : viteEnv.VITE_API_BASE_URL)
            return viteEnv.VITE_API_BASE_URL;
        // Next.js apps
        const nextEnv = window.__ENV__;
        if (nextEnv === null || nextEnv === void 0 ? void 0 : nextEnv.NEXT_PUBLIC_API_URL)
            return nextEnv.NEXT_PUBLIC_API_URL;
    }
    // Node.js / build time
    if (typeof process !== 'undefined' && process.env) {
        return process.env.NEXT_PUBLIC_API_URL || process.env.VITE_API_BASE_URL || process.env.VITE_API || '/api';
    }
    return '/api';
}
// Create axios client with unified interceptors
export function createApiClient(config = {}) {
    const { baseURL = getApiUrl(), timeout = 30000, onUnauthorized, tokenKey = 'token', } = config;
    const client = axios.create({
        baseURL,
        timeout,
        headers: {
            'Content-Type': 'application/json',
        },
    });
    // Request interceptor - add token
    client.interceptors.request.use((config) => {
        const token = store.get(tokenKey) || localStorage.getItem('access_token');
        if (token && config.headers) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    }, (error) => Promise.reject(error));
    // Response interceptor - handle errors
    client.interceptors.response.use((response) => response, (error) => {
        const { response } = error;
        if (response) {
            const { status } = response;
            if (status === 401) {
                // Clear tokens
                store.remove(tokenKey);
                store.remove('refreshToken');
                store.remove('user');
                store.remove('roles');
                store.remove('permissions');
                localStorage.removeItem('access_token');
                // Custom handler or default redirect
                if (onUnauthorized) {
                    onUnauthorized();
                }
                else if (typeof window !== 'undefined' && window.location.pathname !== '/login') {
                    const currentPath = window.location.pathname;
                    window.location.href = `/login?redirect=${encodeURIComponent(currentPath)}`;
                }
            }
        }
        return Promise.reject(error);
    });
    // Convenience API methods (scheduling style)
    const api = {
        get: (url, params) => client.get(url, { params }).then((res) => res.data),
        post: (url, data) => client.post(url, data).then((res) => res.data),
        put: (url, data) => client.put(url, data).then((res) => res.data),
        patch: (url, data) => client.patch(url, data).then((res) => res.data),
        delete: (url, params) => client.delete(url, { params }).then((res) => res.data),
    };
    return { client, api };
}
// Default singleton instance
const defaultInstance = createApiClient();
// Export axios instance (admin style - direct axios usage)
export const apiClient = defaultInstance.client;
// Export api object (scheduling style - convenience methods)
export const api = defaultInstance.api;
// Re-export axios for direct usage
export { axios };
export default apiClient;
//# sourceMappingURL=axios-client.js.map